import moment from 'moment';

export default function parseDaytime(daytime, useUtc) {
  const arr = daytime.split(':');
  const hours = Number.parseInt(arr[0], 10);
  const minutes = Number.parseInt(arr[1], 10);

  if (useUtc) {
    return moment.utc().hour(hours).minute(minutes).second(0).valueOf();
  }

  return moment().hour(hours).minute(minutes).second(0).valueOf();
}
